import React, { useEffect, useMemo, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import logoFajjPro from "../../assets/images/sponsors/logo-fajjpro.png"
import logoEduadoAssis from "../../assets/images/sponsors/logo-eduardo-assis.png"
import barbeariaEmanuel from "../../assets/images/sponsors/barbearia-Emanuel.png"

//Apoio
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";
import Papa from "papaparse";
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import logoTorneiofacil from "../../assets/images/branding/logo-torneiofacil.png";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";

const sponsors = [
  { img: torneio, url: "http://www.torneiofacil.com" },

];

const support = [
  { img: logoEduadoAssis, url: "" },
  { img: logoFajjPro, url: "" },
  { img: barbeariaEmanuel, url: "" },
  { img: torneio, url: "http://www.torneiofacil.com" },
];

const CHAVES_GI_CSV_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vSeANNy3HrVRihQndU3PZU_FF2ahkssGk-BZn4_DADVDsrh8CF8RJ3pfMYZ42-1i8EtGHMnZDEX-TWM/pub?gid=0&single=true&output=csv";
const CHAVES_NOGI_CSV_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vSeANNy3HrVRihQndU3PZU_FF2ahkssGk-BZn4_DADVDsrh8CF8RJ3pfMYZ42-1i8EtGHMnZDEX-TWM/pub?gid=1488497812&single=true&output=csv";

const cacheBuster = `?cacheBuster=${new Date().getTime()}`
const dataEvento = "26 de abril de 2026"
const horaEvento = "16:00hrs"
const tituloEvento = "Desafio Zona Norte de Jiu Jitsu Gi e Nogi 2026"
const localEvento = "Praça de alimentação da Cidade Nova 1"
const endereçoEvento = "Av. Atroaris, 4 - Cidade Nova 1, Ao lado do lanche Sortidinho - Manaus - AM, CEP 69090-220"
const dataDeEncerramentoIncricao = "22/ABR/2026"
const horaDeEncerramentoIncricao = "17:00h"

const dataDeEncerramentoCorrecao = "22/ABR/2026"
const horaDeEncerramentoCorrecao = "17:00h"

//Valores
const valorinscricaoCategoria = "35,00 (trinta e cinco reais)"
const valorinscricaoComboGieNogi = "70,00 (setenta reais)"

const dataDeDivulgacaoChaves = "25/ABR/2026 "
const horaDeDivulgacaoChaves = "23h:59min"

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp1 = "+55 92 99972-6760"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-gi";
const slugNOGI = "desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-nogi";
const rotaInscriçaoGi = `/enrollment/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-gi`;
const rotaChecagemGi = "/check/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-gi/search";
const rotaChecagemNogi = "/check/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-nogi/search";
const rotaChavesGi = "/tournament/keys/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-gi"
const rotaChavesNogi = "/tournament/keys/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-nogi"


const DesafioZonaNorteDeJiuJitsuManausAm2026: React.FC = () => {
  const { authenticated, getToken, account } = useAuthenticate();
  const isAdmin = account?.id === 34;
  const navigate = useNavigate();

  const [chavesGiModalOpen, setChavesGiModalOpen] = useState(false);
  const [chavesGiRows, setChavesGiRows] = useState<any[]>([]);
  const [chavesGiLoading, setChavesGiLoading] = useState(false);
  const [searchChavesGi, setSearchChavesGi] = useState("");

  const [chavesNogiModalOpen, setChavesNogiModalOpen] = useState(false);
  const [chavesNogiRows, setChavesNogiRows] = useState<any[]>([]);
  const [chavesNogiLoading, setChavesNogiLoading] = useState(false);
  const [searchChavesNogi, setSearchChavesNogi] = useState("");

  const [relatorioOpen, setRelatorioOpen] = useState<"gi" | "nogi" | null>(null);

  const loadChavesGi = async () => {
    setChavesGiLoading(true);
    try {
      const res = await fetch(`${CHAVES_GI_CSV_URL}&t=${Date.now()}`);
      const csvText = await res.text();
      const parsed = Papa.parse(csvText, { header: true });
      const cleaned = (parsed.data as any[]).filter(
        (row) => row && Object.values(row).some((v) => String(v ?? "").trim() !== "")
      );
      setChavesGiRows(cleaned);
    } catch {
      toast.error("Erro ao carregar chaves GI");
    } finally {
      setChavesGiLoading(false);
    }
  };

  const loadChavesNogi = async () => {
    setChavesNogiLoading(true);
    try {
      const res = await fetch(`${CHAVES_NOGI_CSV_URL}&t=${Date.now()}`);
      const csvText = await res.text();
      const parsed = Papa.parse(csvText, { header: true });
      const cleaned = (parsed.data as any[]).filter(
        (row) => row && Object.values(row).some((v) => String(v ?? "").trim() !== "")
      );
      setChavesNogiRows(cleaned);
    } catch {
      toast.error("Erro ao carregar chaves NOGI");
    } finally {
      setChavesNogiLoading(false);
    }
  };

  const normalize = (s: string) =>
    s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();

  const getColVal = (row: any, includes: string): string => {
    const key = Object.keys(row).find((k) => normalize(k).includes(normalize(includes)));
    return key ? String(row[key] ?? "").trim() : "";
  };

  const buildRowText = (row: any, i: number): string => {
    const allCols = Object.values(row).map((v) => String(v ?? "").trim()).join(" ");
    const fightNum = getColVal(row, "numero de luta") || getColVal(row, "luta") || String(i + 1);
    return `${allCols} luta ${fightNum}`.toLowerCase();
  };

  const filteredChavesGi = useMemo(() => {
    if (!searchChavesGi.trim()) return chavesGiRows;
    const q = searchChavesGi.toLowerCase();
    return chavesGiRows.filter((row, i) => buildRowText(row, i).includes(q));
  }, [chavesGiRows, searchChavesGi]);

  const filteredChavesNogi = useMemo(() => {
    if (!searchChavesNogi.trim()) return chavesNogiRows;
    const q = searchChavesNogi.toLowerCase();
    return chavesNogiRows.filter((row, i) => buildRowText(row, i).includes(q));
  }, [chavesNogiRows, searchChavesNogi]);

  const highlight = (text: string, query: string): React.ReactNode => {
    if (!query.trim() || !text) return text;
    const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const parts = text.split(new RegExp(`(${escaped})`, "gi"));
    return (
      <>
        {parts.map((part, i) =>
          i % 2 === 1 ? (
            <mark key={i} style={{ backgroundColor: "#fef08a", padding: 0, color: "inherit" }}>
              {part}
            </mark>
          ) : (
            part
          )
        )}
      </>
    );
  };

  const generateLutasPDF = async (rows: any[], modalidade: "GI" | "NOGI") => {
    const fontBytes = await fetch("/DejaVuSans.ttf").then((r) => r.arrayBuffer());
    const logoBytes = await fetch(logoTorneiofacil).then((r) => r.arrayBuffer());

    const A4_W = 595.28;
    const A4_H = 841.89;
    const margin = 25;

    const pdfDoc = await PDFDocument.create();
    pdfDoc.registerFontkit(fontkit);
    const fonte = await pdfDoc.embedFont(fontBytes);
    const logoImg = await pdfDoc.embedPng(logoBytes);

    const navy = rgb(0.102, 0.133, 0.322);
    const red = rgb(0.894, 0.125, 0.173);
    const gray500 = rgb(0.42, 0.455, 0.565);
    const gray300 = rgb(0.769, 0.788, 0.847);
    const gray50 = rgb(0.969, 0.973, 0.984);
    const white = rgb(1, 1, 1);

    const contentW = A4_W - 2 * margin;
    const fightHeaderH = 16;
    const athleteRowH = 20;
    const fightGap = 8;
    const fontSize = 9;
    const headerFontSize = 7;

    let page = pdfDoc.addPage([A4_W, A4_H]);
    let curY = A4_H - margin;

    const addNewPage = () => {
      page = pdfDoc.addPage([A4_W, A4_H]);
      curY = A4_H - margin;
    };

    const drawPageHeader = () => {
      const smallLogoW = 95;
      const smallLogoH = (logoImg.height / logoImg.width) * smallLogoW;
      const headerH = Math.max(smallLogoH, 28);

      page.drawImage(logoImg, { x: margin, y: curY - smallLogoH, width: smallLogoW, height: smallLogoH });

      const title = tituloEvento.toUpperCase();
      const titleW = fonte.widthOfTextAtSize(title, 11);
      page.drawText(title, { x: (A4_W - titleW) / 2, y: curY - 12, size: 11, font: fonte, color: navy });

      const subtitle = `LUTAS CAÇADAS — ${modalidade}`;
      const subW = fonte.widthOfTextAtSize(subtitle, 8);
      page.drawText(subtitle, { x: (A4_W - subW) / 2, y: curY - 24, size: 8, font: fonte, color: gray500 });

      curY -= headerH + 6;
      page.drawLine({ start: { x: margin, y: curY }, end: { x: A4_W - margin, y: curY }, thickness: 1.5, color: red });
      curY -= 16;
    };

    drawPageHeader();

    // Agrupar por categoria se a coluna existir
    const hasCategory = rows.length > 0 && !!getColVal(rows[0], "categoria").trim();
    const grouped: { label: string; fights: any[] }[] = [];
    if (hasCategory) {
      const map = new Map<string, any[]>();
      rows.forEach((row) => {
        const cat = getColVal(row, "categoria") || "SEM CATEGORIA";
        if (!map.has(cat)) map.set(cat, []);
        map.get(cat)!.push(row);
      });
      map.forEach((fights, label) => grouped.push({ label, fights }));
    } else {
      grouped.push({ label: "", fights: rows });
    }

    const drawCategoryHeader = (label: string) => {
      if (curY - (fightHeaderH + athleteRowH * 2 + fightGap + 30) < 50) { addNewPage(); drawPageHeader(); }
      page.drawRectangle({ x: margin, y: curY - fightHeaderH - 4, width: contentW, height: fightHeaderH + 4, color: navy });
      const cw = fonte.widthOfTextAtSize(label.toUpperCase(), 9);
      page.drawText(label.toUpperCase(), { x: (A4_W - cw) / 2, y: curY - fightHeaderH, size: 9, font: fonte, color: white });
      curY -= fightHeaderH + 4 + 6;
    };

    const drawFightBlock = (row: any, fightIdx: number) => {
      const a1Name   = getColVal(row, "atleta 1");
      const a1Gym    = getColVal(row, "academia 1");
      const a1Belt   = getColVal(row, "faixa 1");
      const a1Weight = getColVal(row, "peso 1");
      const a1Age    = getColVal(row, "idade 1");

      const a2Name   = getColVal(row, "atleta 2");
      const a2Gym    = getColVal(row, "academia 2");
      const a2Belt   = getColVal(row, "faixa 2");
      const a2Weight = getColVal(row, "peso 2");
      const a2Age    = getColVal(row, "idade 2");

      const a2IsSolo = !a2Name || a2Name === "-" || a2Name === "";
      const fightNum = getColVal(row, "numero de luta") || getColVal(row, "luta") || String(fightIdx + 1);

      const totalH = fightHeaderH + athleteRowH * (a2IsSolo ? 2 : 2) + fightGap;
      if (curY - totalH < 50) { addNewPage(); drawPageHeader(); }

      const bgColor = fightIdx % 2 === 0 ? gray50 : white;

      // Cabeçalho da luta: LUTA N (azul-escuro)
      page.drawRectangle({ x: margin, y: curY - fightHeaderH, width: contentW, height: fightHeaderH, color: navy });
      const label = `LUTA ${fightNum}`;
      const lw = fonte.widthOfTextAtSize(label, headerFontSize);
      page.drawText(label, { x: margin + (contentW - lw) / 2, y: curY - fightHeaderH + 5, size: headerFontSize, font: fonte, color: white });
      curY -= fightHeaderH;

      const drawAthleteLine = (
        num: string, name: string, belt: string, weight: string, age: string, gym: string,
        isLast: boolean
      ) => {
        page.drawRectangle({ x: margin, y: curY - athleteRowH, width: contentW, height: athleteRowH, color: bgColor });
        const textY = curY - athleteRowH + 7;

        // Lado esquerdo: número + nome, depois faixa/peso/idade separados por " - "
        const details = [belt?.toUpperCase(), weight?.split(";")[0]?.toUpperCase(), age ? `${age} anos` : ""].filter(Boolean).join(" - ");
        const left = details ? `${num}  ${name?.toUpperCase() || "-"}   ${details}` : `${num}  ${name?.toUpperCase() || "-"}`;
        page.drawText(left || `${num} -`, { x: margin + 8, y: textY, size: fontSize, font: fonte, color: rgb(0, 0, 0) });

        // Lado direito: academia sem corte
        if (gym && gym !== "-") {
          const gymUp = gym.toUpperCase();
          const gw = fonte.widthOfTextAtSize(gymUp, fontSize);
          page.drawText(gymUp, { x: margin + contentW - gw - 8, y: textY, size: fontSize, font: fonte, color: gray500 });
        }

        page.drawLine({ start: { x: margin, y: curY - athleteRowH }, end: { x: margin + contentW, y: curY - athleteRowH }, thickness: isLast ? 0.8 : 0.3, color: gray300 });
        curY -= athleteRowH;
      };

      // Linha atleta 1
      drawAthleteLine("1.", a1Name, a1Belt, a1Weight, a1Age, a1Gym, false);

      // Linha atleta 2 (ou "CASAR NA HORA")
      if (a2IsSolo) {
        page.drawRectangle({ x: margin, y: curY - athleteRowH, width: contentW, height: athleteRowH, color: bgColor });
        page.drawText("2.  CASAR NA HORA DO EVENTO", { x: margin + 8, y: curY - athleteRowH + 7, size: fontSize, font: fonte, color: gray500 });
        page.drawLine({ start: { x: margin, y: curY - athleteRowH }, end: { x: margin + contentW, y: curY - athleteRowH }, thickness: 0.8, color: gray300 });
        curY -= athleteRowH;
      } else {
        drawAthleteLine("2.", a2Name, a2Belt, a2Weight, a2Age, a2Gym, true);
      }

      curY -= fightGap;
    };

    for (const group of grouped) {
      if (group.fights.length === 0) continue;
      if (hasCategory && group.label) drawCategoryHeader(group.label);
      group.fights.forEach((row, i) => drawFightBlock(row, i));
      curY -= 8;
    }

    // Footers
    const allPages = pdfDoc.getPages();
    const total = allPages.length;
    allPages.forEach((p, i) => {
      p.drawLine({ start: { x: margin, y: 25 }, end: { x: A4_W - margin, y: 25 }, thickness: 1, color: navy });
      p.drawText(localEvento, { x: margin, y: 13, size: 7, font: fonte, color: gray500 });
      const rt = `www.torneiofacil.com.br ${i + 1}/${total}`;
      const rw = fonte.widthOfTextAtSize(rt, 7);
      p.drawText(rt, { x: A4_W - margin - rw, y: 13, size: 7, font: fonte, color: gray500 });
    });

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `LUTAS CAÇADAS ${modalidade} - ${tituloEvento}.pdf`;
    link.click();
  };

  const computeRelatorio = (rows: any[]) => {
    const totalLutas = rows.length;
    const casadas = rows.filter((row) => {
      const a2 = getColVal(row, "atleta 2");
      return a2 && a2 !== "-";
    }).length;
    const semPar = totalLutas - casadas;
    const totalAtletas = casadas * 2 + semPar;

    const academiaCount: Record<string, number> = {};
    rows.forEach((row) => {
      const ac1 = getColVal(row, "academia 1");
      const ac2 = getColVal(row, "academia 2");
      if (ac1 && ac1 !== "-") academiaCount[ac1] = (academiaCount[ac1] || 0) + 1;
      if (ac2 && ac2 !== "-") academiaCount[ac2] = (academiaCount[ac2] || 0) + 1;
    });
    const academias = Object.entries(academiaCount).sort((a, b) => b[1] - a[1]);

    const beltCount: Record<string, number> = {};
    rows.forEach((row) => {
      const b1 = getColVal(row, "faixa 1");
      const b2 = getColVal(row, "faixa 2");
      if (b1 && b1 !== "-") beltCount[b1] = (beltCount[b1] || 0) + 1;
      if (b2 && b2 !== "-") beltCount[b2] = (beltCount[b2] || 0) + 1;
    });
    const faixas = Object.entries(beltCount).sort((a, b) => b[1] - a[1]);

    return { totalLutas, casadas, semPar, totalAtletas, academias, faixas };
  };

  const renderFightCards = (rows: any[], query: string, admin: boolean = false) =>
    rows.map((row, i) => {
      const fightNum = getColVal(row, "numero de luta") || getColVal(row, "luta") || String(i + 1);
      const a1Name = getColVal(row, "atleta 1");
      const a1Academy = getColVal(row, "academia 1");
      const a1Age = getColVal(row, "idade 1");
      const a1Weight = getColVal(row, "peso 1");
      const a1Belt = getColVal(row, "faixa 1");

      const a2Name = getColVal(row, "atleta 2");
      const a2Academy = getColVal(row, "academia 2");
      const a2Age = getColVal(row, "idade 2");
      const a2Weight = getColVal(row, "peso 2");
      const a2Belt = getColVal(row, "faixa 2");

      const a2IsSolo = !a2Name || a2Name === "-" || a2Name === "";

      const a1Info = admin ? [a1Belt, a1Weight, a1Age ? `${a1Age} anos` : ""].filter(Boolean).join(" — ") : "";
      const a2Info = admin ? [a2Belt, a2Weight, a2Age ? `${a2Age} anos` : ""].filter(Boolean).join(" — ") : "";

      const a1Line = `1. ${a1Name}${a1Academy ? ` — ${a1Academy}` : ""}${a1Info ? ` — ${a1Info}` : ""}`;
      const a2Line = `2. ${a2Name}${a2Academy ? ` — ${a2Academy}` : ""}${a2Info ? ` — ${a2Info}` : ""}`;
      const lutaLabel = `Luta ${fightNum}`;

      return (
        <Box key={i} sx={{ mb: 2 }}>
          <Box sx={{ fontSize: "0.75rem", fontWeight: "bold", color: "#1a2252", mb: 0.5, textTransform: "uppercase", letterSpacing: "0.05em" }}>
            {highlight(lutaLabel, query)}
          </Box>
          <Box sx={{ border: "1px solid rgba(26,34,82,0.12)", borderRadius: "8px", overflow: "hidden", boxShadow: "0 1px 3px rgba(26,34,82,0.06)" }}>
            {/* Atleta 1 */}
            <Box sx={{ backgroundColor: "#eef0f5", px: 2, py: 1.2 }}>
              <span style={{ color: "#6b7490", fontStyle: "italic", fontWeight: "bold", textTransform: "uppercase" }}>
                {highlight(a1Line, query)}
              </span>
            </Box>
            {/* Atleta 2 */}
            {a2IsSolo ? (
              <Box sx={{ backgroundColor: "#f7f8fb", borderTop: "2px dashed #9098b0", px: 2, py: 1.2 }}>
                <span style={{ color: "#6b7490", fontStyle: "italic", fontWeight: "bold", textTransform: "uppercase" }}>
                  2. ATLETA 2 — CASAR NA HORA DO EVENTO
                </span>
              </Box>
            ) : (
              <Box sx={{ backgroundColor: "#fff", borderTop: "1px solid rgba(26,34,82,0.08)", px: 2, py: 1.2 }}>
                <span style={{ color: "#6b7490", fontStyle: "italic", fontWeight: "bold", textTransform: "uppercase" }}>
                  {highlight(a2Line, query)}
                </span>
              </Box>
            )}
          </Box>
        </Box>
      );
    });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleToSubscriptionPage = async () => {

    if (!authenticated) {
      Swal.fire({
        title: 'Você precisa estar autenticado',
        text: 'Deseja fazer login para se inscrever no evento?',
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Fazer login',
        focusConfirm: false,
        cancelButtonText: 'Agora não'
      }).then((action) => {
        if (action.isConfirmed) navigate('/login')
      });
      return;
    }

    const response = await api.get(
      `/tournaments/info/${slugGI}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );

    if (response.data.canSubscribe === false) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Período de inscrição encerrado!',
        icon: 'error',
      });
      toast.error('Período de inscrição encerrado!');
      return;
    }

    navigate(`/enrollment/${slugGI}`)

  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-banner.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-banner.jpeg")}
              // imageMobile={require("../../assets/images/tournaments/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-banner.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                 <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                 <a
                  target={"blank"}
                  style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                  href="https://maps.app.goo.gl/zTiu23jKr2Wvy1hT9"
                  >
                    Ver no Google Maps
                  </a>
                  </div>
                </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index}
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank"
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                    O {tituloEvento} é um evento de LUTAS CASADAS (1x1) que fomenta e incentiva a prática do Jiu-Jitsu no Estado do Amazonas.
                    Cada atleta realizará apenas uma luta previamente casada pela organização, respeitando faixa, idade e peso aproximado.
                    Não haverá sistema de chaves eliminatórias. Os competidores terão a oportunidade de testar suas
                    habilidades em um ambiente controlado e com acompanhamento de
                    profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                </Collapse>
                <Collapse title="PREMIAÇÕES" >

                <H3>
                  Academia:
                </H3>
                <P>
                  1ª Lugar - R$1.000,00 para equipe com maior quantidade de atletas inscritos.
                </P>

                  <H3>Atletas:</H3>
                  <P>Premiação somente para o campeão.</P>

                  <H3>O resultado será definido como:</H3>
                  <P>- Vitória</P>
                  <P>- Derrota</P>
                  <P>- Empate (caso aplicável)</P>

                  <br />
                  {/* <H3>Academias:</H3>
                  <P>A premiação por equipe será definida com base na
                    pontuação por resultado das lutas casadas.</P>

                  <br /> */}
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2026, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2026,
                    conforme regra da CBJJ.
                  </P>
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até  {dataDeEncerramentoIncricao}, às {""}
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />

                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação do pagamento
                    da mesma.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <br />
                  <H3>Chaves</H3>
                  <P>
                    A divulgação do CARD OFICIAL DAS LUTAS CASADAS será realizada em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.

                  </P>
                  <P>
                     Não haverá sorteio de chaves, pois o formato é exclusivamente de lutas casadas.
                  </P>

                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>

                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <P>Inscrição categoria GI ou NOGI: R$ {valorinscricaoCategoria} </P>
                  <P>Inscrição Combo GI + NOGI: R$ {valorinscricaoComboGieNogi} </P>
                  <p>Pagamento até 22/ABR/2026 às 17:00h</p>
                  <br />
                  <P>Faixas: Todas as faixas — Pré-mirim ao Master</P>
                  <br />
                </Collapse>

                <Collapse title="PAGAMENTO">
                  <H3>
                    A baixa do pagamento será efetuada de forma automática.
                  </H3>
                  <H3>
                    É necessário completar todas as etapas até finalizar a operação de pagamento.
                  </H3>
                  <p />
                </Collapse>

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Uma vez PAGA a inscrição, o atleta tem direito ao reembolso nas seguintes situações:
                  </H3>
                  <P>
                    1) Quando o evento é CANCELADO.
                  </P>
                  <P>
                    2) Quando ocorre alteração na DATA do evento.
                  </P>
                  <P>
                    3) Quando altera o LOCAL do evento com distância maior que 20km em relação ao anterior.
                  </P>
                  <P>
                    4) Quando há diminuição da premiação, somente para os atletas impactados.
                  </P>
                  <H3>
                    Obs: Para os 4 casos acima, o prazo máximo para solicitar reembolso será de até 5 dias (corridos)
                    após a divulgação do COMUNICADO no site www.torneiofacil.com.br ou DATA FIM da CHECAGEM GERAL ABERTA ( a data que ocorrer primeiro ).
                  </H3>
                  <P>
                    Em caso de CALAMIDADE PÚBLICA, PANDEMIA, CATÁSTROFE NATURAL e DECRETOS GOVERNAMENTAIS, considerados motivo de FORÇA MAIOR,
                    o atleta NÃO TEM direito ao reembolso.
                  </P>
                  <P>
                    Para estes casos, a organização oferecerá alternativas para uso do crédito do atleta que não puder comparecer na nova data
                    do evento, ao invés do reembolso, desde que o atleta nos notifique pelo FALE CONOSCO até SEGUNDA-FEIRA antecedente ao evento).
                  </P>
                  <P>
                    Após os períodos predeterminados, o atleta perderá o direito a reembolso ou crédito.
                  </P>
                  <H3>
                    Além disso, o atleta NÃO tem direito a reembolso de valores quando:
                  </H3>

                  <P>
                    1) Se machuca antes do evento impossibilitando o atleta de participar do mesmo.
                  </P>
                  <P>
                    2) Desistência por qualquer motivo.
                  </P>
                    <H3>
                      Em caso de não formação da luta por ausência de adversário, a organização poderá:
                    </H3>
                     <ul>
                       <li>
                        Substituir o adversário
                      </li>
                      <li>
                        Reorganizar o card
                      </li>
                      <li>
                        Oferecer crédito
                      </li>
                      <li>
                        Realizar reembolso
                      </li>
                      </ul>
                </Collapse>

                <Collapse title="REGRAS">

                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                    Não haverá categorias com três atletas ou sistema de final automática.
                  </Span>
                  <Span>
                    Cada atleta realizará apenas uma luta casada.
                  </Span>
                  <Span>
                    Em caso de WO, será declarada vitória ao atleta presente.
                  </Span>
                  <Span>
                    Todas as vitórias contam pontos normalmente para sua equipe, independentemente da academia do adversário.
                  </Span>
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados.
                  </Span>
                  <Span>
                    Para viabilizar o casamento das lutas, poderá haver agrupamento técnico de faixas conforme critério da organização:
                  </Span>
                  <P> Branca; </P>
                  <P> Cinza, Amarela , Laranja e Verde - (Graduados)</P>
                  <P> Azul; </P>
                  <P> Roxa; </P>
                  <P> Marrom; </P>
                  <P> Preta. </P>
                  <Span> Será permitida a inscrição de atletas Juvenil na faixa Verde, porém
                    ele lutará como Juvenil faixa Azul.
                  </Span>
                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span>
                  <Span>Teremos duas balanças para pesagem oficial dos atletas.</Span>
                  <Span>
                    Não haverá categoria Absoluto, pois o formato do evento é exclusivamente de lutas casadas.
                  </Span>
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso.
                  </Span>
                  <br />
                  <H3>Pontuação por Equipe – Lutas Casadas</H3>
                  <P>- Vitória por finalização: 5 pontos</P>
                  <P>- Vitória por pontos: 3 pontos</P>
                  <P>- Empate: 1 ponto para cada atleta</P>
                  <P>
                    - Derrota: 0 pontos
                  </P>
                  <P>
                    A equipe campeã será aquela que somar o maior número de pontos ao final do evento.
                  </P>
                  <H3>
                    Critérios de desempate:
                  </H3>
                  <ul>
                    <li>
                      Maior número de vitórias
                    </li>
                    <li>
                      Maior número de finalizações
                    </li>
                    <li>
                      Menor número de punições
                    </li>
                  </ul>
                  <br />
                  <P>
                   As regras técnicas de combate seguirão o livro oficial da CBJJ quanto a pontuação, penalidades e condutas disciplinares.
                   O formato competitivo será exclusivamente de Lutas Casadas.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
                (EM BREVE)

                  <Container>
                  </Container>
                </Collapse>
                <Collapse title="ENTRADA">
                  <P>
                    Liberada ao público.
                  </P>
                </Collapse>
                <Collapse title="CONTATO">
                  <P>Caso Precise falar com o responsável do evento, entre em contato por telefone ou WhatsApp.</P>
                  <a target={"blank"} href="https://whatsa.me/5592999726760/?t=Ol%C3%A1!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*DESAFIO%20ZONA%20NORTE%20DE%20JIU%20JITSU%20GI%20E%20NOGI%202026*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp1} (Rafaela Farache) </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  <br />
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Ol%C3%A1%20Equipe%20Torneio%20F%C3%A1cil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*DESAFIO%20ZONA%20NORTE%20DE%20JIU%20JITSU%20GI%20E%20NOGI%202026*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage()}>
                Inscrição
              </TournamentEnrollmentLinkEndpage>

              <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                Correção da Inscrição
              </TournamentEnrollmentLinkEndpage>

              <TournamentLink
                href={rotaChecagemGi}
              >
                Checagem GI
              </TournamentLink>
              <TournamentLink
                href={rotaChecagemNogi}
              >
                Checagem NOGI
              </TournamentLink>

              {/* <TournamentLink href={rotaChavesGi}>Chaves GI</TournamentLink> */}
              {/* <TournamentLink href={rotaChavesNogi}>Chaves NOGI</TournamentLink> */}

              <TournamentLink
                onClick={() => {
                  setChavesGiModalOpen(true);
                  loadChavesGi();
                }}
              >
                Chaves GI
              </TournamentLink>
              <TournamentLink
                onClick={() => {
                  setChavesNogiModalOpen(true);
                  loadChavesNogi();
                }}
              >
                Chaves NOGI
              </TournamentLink>
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Dialog
        open={chavesGiModalOpen}
        onClose={() => setChavesGiModalOpen(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
          <DialogTitle sx={{ p: 0, fontWeight: "bold" }}>
            Chaves GI — Lutas Casadas
          </DialogTitle>
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {isAdmin && (
              <Button
                size="small"
                variant="outlined"
                onClick={() => setRelatorioOpen("gi")}
                sx={{ borderColor: "#1a2252", color: "#1a2252", fontFamily: "inter, sans-serif", textTransform: "none" }}
              >
                Relatório
              </Button>
            )}
            <IconButton onClick={() => setChavesGiModalOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        <TextField
          fullWidth
          placeholder="Pesquisar por atleta, academia, faixa, peso, idade, número da luta..."
          value={searchChavesGi}
          onChange={(e) => setSearchChavesGi(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          size="small"
          sx={{ px: 2, pb: 1 }}
        />

        <DialogContent sx={{ p: 2 }}>
          {chavesGiLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 6 }}>
              <CircularProgress sx={{ color: "#1a2252" }} />
            </Box>
          ) : filteredChavesGi.length === 0 ? (
            <Box sx={{ textAlign: "center", color: "#888", py: 4 }}>Nenhuma luta encontrada.</Box>
          ) : renderFightCards(filteredChavesGi, searchChavesGi, isAdmin)}
        </DialogContent>
      </Dialog>

      <Dialog
        open={chavesNogiModalOpen}
        onClose={() => setChavesNogiModalOpen(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
          <DialogTitle sx={{ p: 0, fontWeight: "bold" }}>
            Chaves NOGI — Lutas Casadas
          </DialogTitle>
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {isAdmin && (
              <Button
                size="small"
                variant="outlined"
                onClick={() => setRelatorioOpen("nogi")}
                sx={{ borderColor: "#1a2252", color: "#1a2252", fontFamily: "inter, sans-serif", textTransform: "none" }}
              >
                Relatório
              </Button>
            )}
            <IconButton onClick={() => setChavesNogiModalOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        <TextField
          fullWidth
          placeholder="Pesquisar por atleta, academia, faixa, peso, idade, número da luta..."
          value={searchChavesNogi}
          onChange={(e) => setSearchChavesNogi(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          size="small"
          sx={{ px: 2, pb: 1 }}
        />

        <DialogContent sx={{ p: 2 }}>
          {chavesNogiLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 6 }}>
              <CircularProgress sx={{ color: "#1a2252" }} />
            </Box>
          ) : filteredChavesNogi.length === 0 ? (
            <Box sx={{ textAlign: "center", color: "#888", py: 4 }}>Nenhuma luta encontrada.</Box>
          ) : renderFightCards(filteredChavesNogi, searchChavesNogi, isAdmin)}
        </DialogContent>
      </Dialog>

      {/* Modal de Relatório — visível somente para usuário 34 */}
      <Dialog
        open={relatorioOpen !== null}
        onClose={() => setRelatorioOpen(null)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2, pb: 0 }}>
          <DialogTitle sx={{ p: 0, fontWeight: "bold", fontFamily: "inter, sans-serif" }}>
            Relatório — Chaves {relatorioOpen === "gi" ? "GI" : "NOGI"}
          </DialogTitle>
          <IconButton onClick={() => setRelatorioOpen(null)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent sx={{ p: 3 }}>
          {(() => {
            const rows = relatorioOpen === "gi" ? chavesGiRows : chavesNogiRows;
            const modalidade = relatorioOpen === "gi" ? "GI" : "NOGI";
            const { totalLutas, casadas, semPar, totalAtletas, academias, faixas } = computeRelatorio(rows);
            return (
              <>
                <Button
                  variant="contained"
                  onClick={() => generateLutasPDF(rows, modalidade)}
                  sx={{ mb: 3, backgroundColor: "#1a2252", fontFamily: "inter, sans-serif", textTransform: "none", "&:hover": { backgroundColor: "#111840" } }}
                >
                  Emitir PDF das Lutas {modalidade}
                </Button>
                <Typography variant="h6" sx={{ fontFamily: "inter, sans-serif", fontWeight: "bold", color: "#1a2252", mb: 1 }}>
                  Relatório de Lutas
                </Typography>
                <Typography sx={{ fontFamily: "inter, sans-serif" }}>{totalLutas} Total de Lutas</Typography>
                <Typography sx={{ fontFamily: "inter, sans-serif" }}>{casadas} Lutas Casadas</Typography>
                <Typography sx={{ fontFamily: "inter, sans-serif" }}>{semPar} Aguardando Par (casar no evento)</Typography>

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6" sx={{ fontFamily: "inter, sans-serif", fontWeight: "bold", color: "#1a2252", mb: 1 }}>
                  Relatório de Atletas
                </Typography>
                <Typography sx={{ fontFamily: "inter, sans-serif" }}>{totalAtletas} Total de Atletas</Typography>
                <Typography sx={{ fontFamily: "inter, sans-serif" }}>{academias.length} Academias</Typography>

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6" sx={{ fontFamily: "inter, sans-serif", fontWeight: "bold", color: "#1a2252", mb: 1 }}>
                  Atletas por Academia
                </Typography>
                {academias.map(([academia, count]) => (
                  <Typography key={academia} sx={{ fontFamily: "inter, sans-serif" }}>
                    {academia}: <b>{count}</b>
                  </Typography>
                ))}

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6" sx={{ fontFamily: "inter, sans-serif", fontWeight: "bold", color: "#1a2252", mb: 1 }}>
                  Atletas por Faixa
                </Typography>
                {faixas.map(([faixa, count]) => (
                  <Typography key={faixa} sx={{ fontFamily: "inter, sans-serif", textTransform: "capitalize" }}>
                    {faixa}: <b>{count}</b>
                  </Typography>
                ))}
              </>
            );
          })()}
        </DialogContent>
      </Dialog>

      <Footer />
    </>
  );
};

export default DesafioZonaNorteDeJiuJitsuManausAm2026;
